// Import components
import './Admindashboard.css';
import React, { useMemo, useState, useEffect } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";
import { Modal, ModalHeader, Card, CardBody, Row, Col,Input,Alert} from 'reactstrap';
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png";
import { Link } from 'react-router-dom';
import axios from "axios";

const initialRows = [];
const initialRowsCat = [];

interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}

const CategoryManagement = () => {



  const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
  const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
      if (reason === "clickaway") { return; }
      setAlertMsgg({ ...alertMsgg, open: false })
  };
  const [showloader, setshowloader] = useState(true);




  const [isEditing, setIsEditing] = useState(false);
  const [modal_center, setmodal_center] = useState(false);

  function removeBodyCss() {
      document.body.classList.add("no_padding");
  }

  interface Category {
      id: number;
      category: string;
      description: string;
  }

  interface FormData {
      id: number | null;
      category: string;
      description: string;
  }

  const [formData, setFormData] = useState<FormData>({
      id: null,
      category: '',
      description: '',
  });

    
  function addCategory(editMode = false, selectedData: Category | null = null) {
      setIsEditing(editMode);
      setErrors({
        category: '',
        description: ''
      });

      console.log("Selected Data:", selectedData); 

      if (editMode && selectedData) {
          setFormData({
              id: selectedData.id, // id can be number here
              category: selectedData.category,
              description: selectedData.description,
          });
      } else {
          setFormData({
              id: null, 
              category: '',
              description: '',
          });
      }
      setmodal_center(true);
      removeBodyCss();
  }

  const fetchcsts = async () => {            
          try { 
          setshowloader(true)
          const response = await axios.get(`/accounts/all_categories`,{ withCredentials: true ,headers: {'Content-Type': 'application/json',},});
          if (response.status === "SENT"){
              const fetchedexps = response.CategoriesData
              .map((item: any) => ({
                  id: item.id,
                  category: item.name, 
                  description: item.description,
                  subcategories: item.subcats.map((i:any)=>(i.name))
              }))
              setRowsCat(fetchedexps);
              setshowloader(false)
          }
          // if (response?.data?.CategoriesData) {
          //     setCategorySet(
          //     response.data.CategoriesData.map((cat: any) => ({
          //         name: titleCase(cat.name),
          //         subcategories: cat.subcats.map((scat: any) => titleCase(scat.name)),
          //     }))
          //     );
          // }
          // if (response.status === "SENT"){
          //     response.CategoriesData.forEach((cat:any)=>{ 
          //     cat.subcats.forEach((scat:any)=>{ 
          //         tempdataarry.push({
          //         id: scat.id,
          //         category: titleCase(cat.name), 
          //         subcategory: scat.name
          //         })
          //     }) 
          //     })
          //     setRows(tempdataarry.reverse());
          // }
          } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                  console.log('Error in stripe payment')
                  setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                  console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                  console.log('An error occurred')
                  setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
              console.log('An error occurred')
              setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }
      };
    

  const [loading, setLoading] = useState(false); // loader state

 const [errors, setErrors] = useState({category: '',description: ''});

  const handleSaveCategory = async () => {
    // if (!formData.category.trim() || !formData.description.trim()) {setAlertMsgg({...alertMsgg,
    //     open: true,content: "Please fill all fields.",type: "error",});
    //     setTimeout(() => {
    //       setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
    //   }, 2000);
    //   return;
    // }
    const newErrors: any = {};

    if (!formData.category.trim()) newErrors.category = 'Category name is required';
    if (!formData.description.trim()) newErrors.description = 'Category description is required';

    if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

    const data = new FormData();
    data.append("cid", formData.id ? formData.id.toString() : "");
    data.append("category", formData.category.trim());
    data.append("description", formData.description.trim());
    data.append("action", formData.id ? "edit" : "add");
    data.append("iscat", "true");

    setLoading(true);

    try {
      setshowloader(true)
      const response = await axios.post("/accounts/handleadmcategory", data, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });

      if (response.status === "DONE") {
          setmodal_center(false);

          setAlertMsgg({...alertMsgg,open: true,content:formData.id ? "Categories updated successfully!":"Categories created successfully!",type: "success",});
          setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
          fetchcsts();
          setshowloader(false);
      }
    
    } catch (error:any) {
      if (error.response) {
          if ([401, 422].includes(error.response.status)) {
            console.log('Error in stripe payment')
            setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
          }
          else if (error.response.status === 403) {
            console.log('Error stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(()=>{window.location.href="/logout"}, 2000)
          } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
          }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
  } finally {setLoading(false);}
  };



  const [deleteIdCat, setDeleteIdCat] = useState<any>(null);
  const [deleteDialogOpenCat, setDeleteDialogOpenCat] = useState(false);
  const handleDeleteClickCat = (id: number) => {  setDeleteIdCat(id); setDeleteDialogOpenCat(true); }; // Open Delete Dialog

  const handleConfirmDeleteCat = async () => {
  
    const data = new FormData();
    data.append('cid', deleteIdCat);
    data.append('action', 'delete' );
    data.append('iscat', 'true')
  
    try {
      setshowloader(true)
      const response = await axios.post("/accounts/handleadmcategory", data, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });
  
      if (response.status === "DONE") {
          setDeleteDialogOpenCat(false); 
          setDeleteIdCat(null);
  
          setAlertMsgg({...alertMsgg,open: true,content: "Category deleted successfully!",type: "success",});
          setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
          setshowloader(false)
          fetchcsts();
      }
      if (response.status === "UTILIZED"){
        setAlertMsgg({ ...alertMsgg, open: true, content:"Category used by an expert!", type:"error" });
        setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
        setshowloader(false)
        fetchcsts();

        // setDeleteDialogOpenCat(false);
        // setDeleteIdCat(null);
      }
    } catch (error:any) {
      if (error.response) {
          if ([401, 422].includes(error.response.status)) {
            console.log('Error in stripe payment')
            setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
          }
          else if (error.response.status === 403) {
            console.log('Error stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(()=>{window.location.href="/logout"}, 2000)
          } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
          }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
  } finally {setLoading(false);}
  };

  const handleCancelDeleteCat = () => { setDeleteDialogOpenCat(false); setDeleteIdCat(null); }; // Cancel Delete



  const columns: column[] = useMemo(
      () => [
        {
          header: 'ID',
          accessorFn: (row) => row.id.toString(),
          enableColumnFilter: false,
          enableSorting: false,
          cell: ({ row }) => row.index + 1,
        },
        {
          header: 'Category',
          accessorKey: 'category',
          enableColumnFilter: false,
          enableSorting: true,
          cell: ({ row }) => (
              <p className="mb-0 fw-medium text-capitalize">
                {row.original.category}
              </p>
            ),
        },
        {
          header: 'Description',
          accessorKey: 'description',
          enableColumnFilter: false,
          enableSorting: true,
          cell: ({ row }) => (
            <div 
              className="font-size-13" 
              style={{
              maxWidth: '800px',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}>
              {row.original.description}
            </div>
          ),
        },
        {
          header: 'Sub Categories',
          accessorKey: 'subcategories',
          enableColumnFilter: false,
          enableSorting: false,
          // cell: ({ row }) => row.original.category.subcategories,
          cell: ({ row }) => (
              <span className="text-capitalize">
                {row.original.subcategories.join(', ')}
              </span>
            ),
        },
        {
          header: 'Action',
          enableColumnFilter: false,
          enableSorting: false,
          cell: ({row}) => (
            <div className="d-flex gap-2 flex-wrap">
              <button className="btn btn-dark btn-sm" onClick={()=>{addCategory(true,row.original)}}>
                <i className="bx bxs-pencil me-1"></i>
                Edit
              </button>
              <button className="btn btn-danger btn-sm" onClick={() => { handleDeleteClickCat(row.original.id); }}>
                <i className="bx bxs-trash-alt me-1"></i>
                Delete
              </button>
              <Link to={`/adminsubcategories?category_id=${row.original.id}`}  className="btn btn-primary  btn-sm">
                <i className="bx bx-duplicate me-1"></i>
                Manage Subcategories
              </Link>
            </div>
          ),

        }
      ],
      []
    );



  const [rows, setRows] = useState(initialRows);
  const [rowsCat, setRowsCat] = useState(initialRowsCat);
    
  var tempdataarry = []
  useEffect(() => {
      
      fetchcsts();

      subscribeToTokenRefresh(() => {
        console.log("🔁 Token refreshed. Re-fetching experts...");
          fetchcsts();
        });
  }, []) 







    document.title = "Categories | BizServe";

    return (
        <div className="page-content">
            <div className="container-fluid">
            {alertMsgg.open && (
            <Alert
            color={alertMsgg.type === "success" ? "success" : "danger"}
            toggle={handleAlertMsggClose}
            style={{ fontWeight: "bold" }}
            fade={false}
            >
            {alertMsgg.content}
            </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
            <div className="spinner">
              <div></div>  
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
            </div>
          </div>
                <Breadcrumbs title="Add Category" breadcrumbItem="Categories" />
                
                <Row>
                    <Col md={12}>
                        <div className="d-flex justify-content-end align-items-start gap-2">
                            <button className="btn btn-primary mb-3" onClick={()=>{addCategory(false);}}>+ Add Category</button>
                        </div>
                    </Col>
                    <Col md={12}>
                        <Card className="rounded-4 border">
                            <CardBody>
                                <TableContainer
                                    columns={columns}
                                    data={rowsCat}
                                    isGlobalFilter={true}
                                    isPagination={true}
                                    SearchPlaceholder="Search By Name..."
                                    pagination="pagination"
                                    paginationWrapper='dataTables_paginate paging_simple_numbers'
                                    tableClass="table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Modal
                    isOpen={modal_center}
                    toggle={() => {
                    addCategory();
                    }}
                    centered
                    className="rounded-4">
                    <ModalHeader className="py-3 px-4" toggle={() => setmodal_center(false)}>
                    <div className="modal-title mt-0 font-size-16 text-dark">
                        {isEditing ? 'Edit Category' : 'Add Category'}
                    </div>
                    </ModalHeader>

                    <div className="modal-body p-4">
                        <Row>
                            <Col lg={12}>
                            <div className="mb-3">
                                <label className="form-label">Category<span className="text-danger px-1">*</span></label>
                                <input
                                className={`form-control ${errors.category ? 'is-invalid' : ''}`}
                                type="text"
                                placeholder="Category Name"
                                value={formData.category}
                                // onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                                onChange={(e) => {
                                      setFormData({ ...formData, category: e.target.value });
                                      setErrors((prev) => ({ ...prev, category: '' })); // clear error
                                    }}
                                  />
                                   {errors.category && <div className="invalid-feedback">{errors.category}</div>}
                                
                            </div>
                            </Col>
                            <Col lg={12}>
                            <div className="">
                                <label className="form-label">Description<span className="text-danger px-1">*</span></label>
                                <Input
                                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                name="metadescription"
                                tag="textarea"
                                id="metadescription"
                                rows={5}
                                placeholder="Category Description"
                                value={formData.description}
                                // onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            onChange={(e) => {
                                  setFormData({ ...formData, description: e.target.value });
                                  setErrors((prev) => ({ ...prev, description: '' }));
                                }}
                              />
                              {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                            </div>
                            </Col>
                            <Col lg={12}>
                            
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary " onClick={handleSaveCategory}>{isEditing ? 'Edit Category': 'Add Category'}</button>
                        {/* <button className="btn btn-success" onClick={handleSaveCategory} disabled={loading}>
                            {loading ? "Saving..." : "Save Category"}
                          </button> */}

                    </div>
                </Modal>


                <Modal
                    isOpen={deleteDialogOpenCat}
                    toggle={() => {
                      setDeleteDialogOpenCat(false);
                    }}
                    centered
                    className="rounded-4">
                    <ModalHeader className="py-3 px-4" toggle={() => {
                        setDeleteDialogOpenCat(false);
                    }}>
                        <div className="modal-title mt-0 font-size-16 text-dark">Delete Category</div>
                    </ModalHeader>
                    <div className="modal-body">
                        <form>
                            <div className="mb-3 px-2">
                            <label htmlFor="message-text" className="col-form-label">Are you sure you want to delete This Category?</label>
                            </div>
                        </form>
                        </div>
                        <div className="modal-footer">
                        <button type="button" className="btn btn-sm  btn-soft-dark" data-bs-dismiss="modal" onClick={handleCancelDeleteCat}>Cancel</button>
                        <button type="button" className="btn btn-sm  btn-danger" onClick={handleConfirmDeleteCat} >Delete</button>
                        </div>
                </Modal>
            </div>
        </div>
    );
};

export default CategoryManagement;
